import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';

@Component({
    selector: 'main-profile-change-email-password',
    template: require('./profile-change-email-password.component.html')    
})

export class MainProfileChangeEmailPasswordComponent implements OnInit {
                
    @Input('invalidPasswordToChangeEmail') wrongPassword: boolean;    
    @Output() userPassword = new EventEmitter();    
    passwordType: String;    
    password: String;    

    constructor() {
                
        this.passwordType = "password";
        this.password = "";                   

    }

    ngOnInit() {        

    }

    ngDoCheck() {

        this.userPassword.emit ({

            value: this.password

        })

    }   

    onChange(flag: any) {

        if (!flag) {
            
            this.passwordType = "password";

        } else {
            
            this.passwordType = "text";

        }

    }

    goBack() {

        window.history.back();
        
    }    

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_change_email_password/profile-change-email-password.component.ts
 **/